export default __webpack_public_path__ + "static/media/pdf.a2a6ccb9.svg";